(function ($, Global) {
    function LoadingComponent() {
        // Déclaration class objet
    }

    LoadingComponent.prototype.initEvents = function () {
        this.subscribers();
    }

    LoadingComponent.prototype.subscribers = function () {
        var self = this;

        $.Topic('loader-show').subscribe(function (selector) {
            var $el = self.checkSelector(selector);

            if (!$el.find(' > .backdrop').exists()) $el.append(self.template());
            $el.addClass('loading');
        });

        $.Topic('loader-hide').subscribe(function (selector) {
            var $el = self.checkSelector(selector);

            $el.removeClass('loading');
        });

        $.Topic('loader-search-show').subscribe(function (selector) {
            var $el = self.checkSelector(selector);

            if (!$el.find(' > .backdrop').exists()) $el.append(self.templateSearch());
            $el.addClass('loading-search');
        });

        $.Topic('loader-search-hide').subscribe(function (selector) {
            var $el = self.checkSelector(selector);

            $el.removeClass('loading-search');
        });
    }

    LoadingComponent.prototype.template = function () {
        return [
            '<div class="backdrop">',
            '<div class="background"></div>',
            '<div class="loader-content"><div class="loader">',
            '<div class="dot dot1"></div>',
            '<div class="dot dot2"></div>',
            '<div class="dot dot3"></div>',
            '<div class="dot dot4"></div>',
            '</div></div>',
            '</div>'
        ].join('');
    }

    LoadingComponent.prototype.templateSearch = function () {
        return [
            '<div class="backdrop">',
            '<div class="background"></div>',
            '<div class= "loader-search-content"><svg version="1.1" id="L4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">',
                '<circle fill="#fff" stroke="none" cx="6" cy="50" r="6">',
                    '<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"></animate>',
               '</circle>',
                '<circle fill="#fff" stroke="none" cx="26" cy="50" r="6">',
                    '<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2"></animate>',
                '</circle>',
                '<circle fill="#fff" stroke="none" cx="46" cy="50" r="6">',
                    '<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"></animate>',
                '</circle>',
            '</svg></div>',
            '</div>'
        ].join('');
    }

    LoadingComponent.prototype.checkSelector = function (selector) {
        if (typeof selector === 'string') return $(selector);

        return typeof selector === 'object' ? selector : $('body');
    }

    Global.LoadingComponent = LoadingComponent;
}(jQuery, window));